import { render, staticRenderFns } from "./certificationList.vue?vue&type=template&id=b27d73c4&scoped=true&"
import script from "./certificationList.vue?vue&type=script&lang=js&"
export * from "./certificationList.vue?vue&type=script&lang=js&"
import style0 from "./certificationList.vue?vue&type=style&index=0&id=b27d73c4&scoped=true&lang=css&"
import style1 from "./certificationList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27d73c4",
  null
  
)

export default component.exports